import { createPortal } from 'react-dom'
import { Tooltip as ReactTooltip } from 'react-tooltip'
import 'react-tooltip/dist/react-tooltip.css'

const Tooltip = ({ id, extraClass, place }) => {
    return createPortal(
        <ReactTooltip
            id={id}
            className={`tooltipHover ${extraClass || ''}`}
            place={place || 'top'}
            delayHide={0}
            opacity={1}
            positionStrategy="fixed"
            style={{
                backgroundColor: '#333',
                color: '#fff',
                zIndex: 9999
            }}
        />,
        document.body
    )
}

const DefaultTooltip = ({ id, className }) => (
    <Tooltip extraClass={className} id={id} />
)

const IconTooltip = ({ id, place }) => (
    <Tooltip
        id={id}
        place={place}
        extraClass={'iconTooltip'}
        stayOpen={false}
    />
)

export default DefaultTooltip

export { DefaultTooltip, IconTooltip, Tooltip }